import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/catch';
// import { OrderService } from 'api/order/order.service';

// import { ProductService } from 'api/product/product.service';
// import { UserdetailsService } from 'api/userdetails/userdetails.service';
// import { UserService } from 'api/user/user.service';
import { BloguserService } from 'api/bloguser/bloguser.service';




declare var $: any;
declare var jQuery: any;

@Component({
    selector: 'application-page',
    templateUrl: './bloguserdetails.html',
})
export class BlogUserdetails implements OnInit {


    isIconSelected: boolean = false;
    IconUrl: any;
    IconFile: File;
    searchvalue: String;
    id: any;
    bloguser = []
    userdetails = []
    email: any

    firstname: string;
    lastname: string;

    mobile: any;
    password: any;
    sortdescription: any;
    facebooklink: any;
    youtubelink: any;
    twitterlink: any;
    linkedinlink: any;
    pinterestlink: any;
    file: File;
    bloggerdesignation : string;

    constructor(private router: Router,
        private bloguserService: BloguserService) {

    }

    ngOnInit() {

        this.email = localStorage.getItem('email')



        this.bloguserService.allbloguser().then(data => {
            if (data) {
                
                this.bloguser = data

                for (let i = 0; i < this.bloguser.length; i++) {
                    if (this.email == this.bloguser[i].email) {

                        this.userdetails.push(this.bloguser[i])
                    }

                }


                this.openpage()

            }
            else {



            }
        })



    }

    openpage() {

        this.firstname = this.userdetails[0]['firstname']
        this.lastname = this.userdetails[0].lastname
        this.mobile = this.userdetails[0].mobile
        this.youtubelink = this.userdetails[0].youtubelink
        this.facebooklink = this.userdetails[0].facebooklink
        this.twitterlink = this.userdetails[0].twitterlink
        this.linkedinlink = this.userdetails[0].linkedinlink
        this.pinterestlink = this.userdetails[0].pinterestlink
        this.sortdescription = this.userdetails[0].sortdescription
       
        this.file = this.userdetails[0].profilepic
        this.id = this.userdetails[0].id
        this.password = this.bloguserService.DescriptPassword(this.userdetails[0].password);
        this.file = this.userdetails[0].profilepic
        this.bloggerdesignation = this.userdetails[0].bloggerdesignation;
        

    }
    createFormData(event) {
        this.file = <File>event.target.files[0];


    }
    removeIconImage() {
        this.IconUrl = "";
        this.IconFile = null;
        this.isIconSelected = false;
    }
    UpdateBlogUser() {



        if (this.firstname == undefined || this.firstname == "") {
            $.notify({
                message: "Please Enter First Name."
            }, {
                    type: 'danger',
                    placement: {
                        from: 'bottom',
                        align: 'right'
                    },
                    delay: 100,
                    timer: 100
                });

            return;
        }
        else if (this.lastname == undefined || this.lastname == "") {
            $.notify({
                message: "Please Enter Last Name."
            }, {
                    type: 'danger',
                    placement: {
                        from: 'bottom',
                        align: 'right'
                    },
                    delay: 100,
                    timer: 100
                });
            return;
        }
        else if (this.mobile == undefined || this.mobile == "") {
            $.notify({
                message: "Please Enter Mobile."
            }, {
                    type: 'danger',
                    placement: {
                        from: 'bottom',
                        align: 'right'
                    },
                    delay: 100,
                    timer: 100
                });
            return;
        }

        else {

            let registeruser =
            {
                firstname: this.firstname,
                lastname: this.lastname,
                email: this.email,
                password: this.password,
                mobile: this.mobile,
                sortdescription: this.sortdescription,


            };


            this.bloguserService.ubloggers(this.id, this.IconFile, registeruser).then(data => {
                if (data) {
                   
                    this.file = data.filename;
                    //   this.ToastMessage(data.message, data.status);
                    if (data.status) {

                        $.notify({
                            message: "Successfully Updated"
                        }, {
                            type: 'success',
                            placement: {
                                from: 'bottom',
                                align: 'right'
                            },
                            delay: 100,
                            timer: 100
                        });

                       
                    }
                    else{

                        this.ngOnInit();

                        $.notify({
                            message: "Error In Updation"
                        }, {
                            type: 'danger',
                            placement: {
                                from: 'bottom',
                                align: 'right'
                            },
                            delay: 100,
                            timer: 100
                        });

                    }
                }
                else{
                    this.ngOnInit();
                }
            })


        }



    }
    detectIconImageChange(event) {

        this.isIconSelected = true;
        let files = event.target.files;
        if (files.length === 0)
            return;

        var mimeType = files[0].type;
        if (mimeType.match(/image\/*/) == null) {
            // this.message = "Only images are supported.";
            return;
        }
        this.IconFile = files[0];
        var reader = new FileReader();

        reader.readAsDataURL(files[0]);
        reader.onload = (_event: any) => {

            var img = new Image();
            img.src = _event.target.result;
            img.onload = () => {
                var width = img.height;
                var height = img.width;
               
                if (height == 512 && width == 512) {
                    this.IconUrl = reader.result;
                }
                else {
                    this.IconUrl = "";
                    this.IconFile = null;
                    this.isIconSelected = false;
                    alert("Image Size must be 512x512")
                }

            }


        }
    }
}



// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/app/structure/bloguserdetails/bloguserdetails.page.ts